const tarifsHeroI18n = {
  "fr": {
    "hero": {
      "title": "Je sélectionne et envoie mes produits",
      "alt": {
        "phones": "Visuel téléphones"
      }
    }
  },
  "en": {
    "hero": {
      "title": "I select and ship my products",
      "alt": {
        "phones": "Phone lineup visual"
      }
    }
  },
  "pl": {
    "hero": {
      "title": "Wybieram i wysyłam moje produkty",
      "alt": {
        "phones": "Wizualizacja telefonów"
      }
    }
  },
  "es": {
    "hero": {
      "title": "Selecciono y envío mis productos",
      "alt": {
        "phones": "Visual de teléfonos"
      }
    }
  },
  "it": {
    "hero": {
      "title": "Seleziona e spedisco i miei prodotti",
      "alt": {
        "phones": "Telefonia visiva"
      }
    }
  },
  "de": {
    "hero": {
      "title": "Ich wähle und versende meine Produkte",
      "alt": {
        "phones": "Telefonaufstellung visuell"
      }
    }
  },
  "pt": {
    "hero": {
      "title": "Eu escolho e envio meus produtos",
      "alt": {
        "phones": "Visualização da linha telefónica"
      }
    }
  },
  "cs": {
    "hero": {
      "title": "Vybírám a posílám své produkty",
      "alt": {
        "phones": "Telefonní sestava vizuální"
      }
    }
  },
  "nl": {
    "hero": {
      "title": "Ik selecteer en verzend mijn producten",
      "alt": {
        "phones": "Telefoonlijn visueel"
      }
    }
  }
};

export default tarifsHeroI18n;
